import { DetailsList, FontSizes, FontWeights, Icon, IconButton, SelectionMode, Stack } from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { netGrossColumn } from "../Utilities/NetGrossField";

function ProjectFeesList(props) {
    const [user] = useContext(AuthContext);

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: "name",
                name: "Opłata",
                ariaLabel: "Nazwa Oplaty",
                fieldName: "name",
                minWidth: 160,
                isRowHeader: true,
                isResizable: true,
            },
            {
                key: "transaction_invoice_id",
                name: "Faktura",
                ariaLabel: "Faktura",
                fieldName: "transaction_invoice_id",
                minWidth: 40,
                maxWidth: 40,
                isResizable: false,
                onRender: (item) => (item.transaction_invoice_id !== null ?
                    <Icon iconName={"CheckMark"} title="Tak" /> : ""),
            },
            {
                key: "recurring",
                name: "Cykliczna",
                ariaLabel: "Cykliczna",
                fieldName: "recurring",
                minWidth: 120,
                isResizable: true,
                onRender: (item) => (item.recurring !== null ?
                    <Icon iconName={"CheckMark"} title={item.recurring} /> : ""),
            },
            {
                key: "created",
                name: "Utworzono",
                ariaLabel: "Utworzono",
                fieldName: "created",
                minWidth: 120,
                isResizable: true,
                onRender: (item) => (item.created === null ? "Rekurencyjna" : item.created),
            },
            {
                minWidth: 120,
                ...netGrossColumn("", "price", "Cena "),
            },
            {
                key: "delete",
                name: "Akcje",
                ariaLabel: "Akcje",
                fieldName: "delete",
                minWidth: 80,
                isRowHeader: true,
                isResizable: true,
                onRender: (item) => (<span>
                <IconButton iconProps={{ iconName: "trash" }} title="Usuń" onClick={() => _delete(item)} />
            </span>),
            },
        ]);
    }, [props.netGross]);


    const _delete = (fee) => {
        fetch(`/api/transaction/${fee.transaction_id}/fee/${fee.id}`, {
            method: "DELETE",
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err);
            });
    };
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>{props.title}</h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none} />
        </Stack.Item>);
    }
    return null;
}

ProjectFeesList.defaultProps = {
    title: "Opłaty",
};

export default ProjectFeesList;